import React, {Component} from "react";

import "./GameConfigurationCard.component.scss";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import {GameConfiguration} from "../../../reducers/gameConfigurations.reducer";
import {Subsidiary} from "../../../../../types/types";
import {checkPermission} from "../../../../../utils/Authorization/authorization";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {Denominations} from "../../../reducers/denominations.reducer";
import {subsidiaryDenominations} from "../../../../../utils/addressUtils";
import {
    getGameConfigurationImagePath,
    resolveGameImageUrl
} from "../../../utils/game-image-url";


export interface GamesCardProps {
    gameConfiguration: GameConfiguration;
    subsidiaries: Subsidiary[];
    edit: any;
    duplicate: any;
    delete: any;
    activate: any;
    deprecated?: boolean;
    move: any;
    engine: any;
    denominations: Denominations[]
}

interface GamesCardState {
    showImagePreview: boolean;
}

export const getGameConfigurationImageUrl = (
    gameConfiguration: GameConfiguration
) => {
    if (!gameConfiguration || !gameConfiguration.image) return undefined;

    const imagePath = getGameConfigurationImagePath(
        gameConfiguration.id,
        gameConfiguration.image
    );

    return resolveGameImageUrl(imagePath);
};

export class GameConfigurationCard extends Component<
    GamesCardProps,
    GamesCardState
> {
    state = {
        showImagePreview: false
    };

    openImagePreview = () => {
        this.setState({showImagePreview: true});
    };

    closeImagePreview = () => {
        this.setState({showImagePreview: false});
    };

    render() {
        const {
            gameConfiguration,
            subsidiaries,
            edit,
            move,
            duplicate,
            engine
        } = this.props;
        const imageUrl = getGameConfigurationImageUrl(gameConfiguration);

        return (
            <div
                className={`info-card ${gameConfiguration.active ? "active" : ""
                }`}
                key={"info-card" + gameConfiguration.id}
            >
                <div className="configuration-card-content">
                    <div className="configuration-card-header">
                        {SubsidiaryUtils.subsidiaryIcon(gameConfiguration.subsidiary)}
                        <div>
                            <div className="game_version">
                                {/*gameConfiguration.engine_version.version*/}

                                <div className="configuration-actions">
                                    {checkPermission("edit_game_configs") && (
                                        <button
                                            className="tooltip-icon"
                                            onClick={() =>
                                                edit(gameConfiguration)
                                            }
                                        >
                                            <span className="tooltip-text">Edit</span>
                                            <i className="icon-pencil-alt-light"></i>
                                        </button>
                                    )}

                                    {checkPermission("move_game_configs") && (
                                        <button
                                            className="tooltip-icon"
                                            onClick={() =>
                                                move(gameConfiguration)
                                            }
                                        >
                                            <span className="tooltip-text">Move</span>
                                            <i className="icon-move-light"></i>
                                        </button>
                                    )}

                                    {checkPermission("edit_game_configs") && (
                                        <button
                                            className="tooltip-icon"
                                            onClick={() =>
                                                duplicate(gameConfiguration)
                                            }
                                        >
                                            <span className="tooltip-text">Clone</span>
                                            <i className="icon-clone-light"></i>
                                        </button>
                                    )}
                                    {checkPermission("delete_game_configs") && (
                                        <button
                                            className="tooltip-icon"
                                            onClick={() =>
                                                this.props.delete(
                                                    gameConfiguration
                                                )
                                            }
                                        >
                                            <span className="tooltip-text">Delete</span>
                                            <i className="icon-trash-alt-light"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {imageUrl && (
                        <button
                            type="button"
                            className="game-configuration-image-preview"
                            aria-label={`View ${gameConfiguration.label} image`}
                            onClick={this.openImagePreview}
                            style={{backgroundImage: `url("${imageUrl}")`}}
                        />
                    )}
                    <div className="configuration-details">
                        <div>
                            <div className="align-flex">
                                <div className="configuration-details-title">
                                    Name
                                </div>
                                <div>{gameConfiguration.label}</div>
                            </div>
                            <div className="align-flex">
                                <div className="configuration-details-title">
                                    Game Config Id
                                </div>
                                <div>{gameConfiguration.id}</div>
                            </div>
                            <div className="align-flex">
                                <div className="configuration-details-title">
                                    Category
                                </div>
                                <div>
                                    {gameConfiguration.game_category
                                        ? gameConfiguration.game_category.name
                                        : "-"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="configuration-details">
                        {Object.keys(engine.game_engine.schema.properties).map(
                            key => {
                                const property =
                                    engine.game_engine.schema.properties[key];
                                if (
                                    gameConfiguration.configuration.hasOwnProperty(
                                        key
                                    )
                                ) {
                                    const sorted = Object.keys(
                                        property.properties
                                    ).sort(
                                        (a, b) =>
                                            property.properties[a]["keyOrder"] -
                                            property.properties[b]["keyOrder"]
                                    );
                                    const current_denominations = this.props.denominations.find(d => d['subsidiary'].includes(gameConfiguration.configuration.subsidiary))
                                    return (
                                        <div key={key}>
                                            <div className="configuration-details-title">
                                                {property.label}
                                            </div>
                                            {sorted.map(subKey => {
                                                if (
                                                    gameConfiguration.configuration[
                                                        key
                                                        ].hasOwnProperty(subKey)
                                                ) {
                                                    const subProperty = property.properties[subKey];

                                                    return (
                                                        <div
                                                            key={subKey}
                                                            className="align-flex"
                                                        >
                                                            <div>{subProperty.label}</div>

                                                            {key === "active_coins" || key === "default_coin" ?
                                                                (
                                                                    <div className="padding-left-15 text-right">
                                                                        {gameConfiguration.configuration[key][subKey].map((d, i, {length}) => {
                                                                            return (
                                                                                <React.Fragment key={i}>
                                                                                    {subsidiaryDenominations[current_denominations["country_id"]]((d / 100).toString())} {length - 1 !== i && " |"}
                                                                                </React.Fragment>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                )
                                                                :
                                                                (
                                                                    subProperty.type === "boolean" ?
                                                                        (
                                                                            <div>
                                                                                <Components.Switch
                                                                                    on={
                                                                                        gameConfiguration
                                                                                            .configuration[
                                                                                            key
                                                                                            ][
                                                                                            subKey
                                                                                            ]
                                                                                    }
                                                                                    onClick={() => {
                                                                                    }}
                                                                                    enabled={
                                                                                        false
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        )
                                                                        :
                                                                        (
                                                                            <div>
                                                                                {gameConfiguration.configuration[key][subKey] &&
                                                                                gameConfiguration.configuration[key][subKey].hasOwnProperty("list")
                                                                                    ? gameConfiguration.configuration[key][subKey]["list"].toString()
                                                                                    : subProperty.hasOwnProperty("enumVal")
                                                                                        ? subProperty.enumVal[subProperty.enum.indexOf(gameConfiguration.configuration[key][subKey])]
                                                                                        : gameConfiguration.configuration[key][subKey]}
                                                                            </div>
                                                                        )


                                                                )
                                                            }


                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                    );
                                }

                                return undefined;
                            }
                        )}
                    </div>
                    {!this.props.deprecated &&
                        checkPermission("enable_game_configs") && (
                            <div className="configuration-footer">
                                <p>Active</p>
                                <span>
                                    <Components.Switch
                                        on={gameConfiguration.active}
                                        onClick={() =>
                                            this.props.activate(
                                                gameConfiguration.id
                                            )
                                        }
                                        enabled={!gameConfiguration.active}
                                    />
                                </span>
                            </div>
                        )}
                </div>
                {imageUrl && this.state.showImagePreview && (
                    <div
                        className="game-configuration-image-lightbox"
                        role="dialog"
                        aria-modal="true"
                        aria-label={`${gameConfiguration.label} image preview`}
                        onClick={this.closeImagePreview}
                    >
                        <div
                            className="game-configuration-image-lightbox-content"
                            onClick={event => event.stopPropagation()}
                        >
                            <button
                                type="button"
                                className="game-configuration-image-lightbox-close"
                                aria-label="Close image preview"
                                onClick={this.closeImagePreview}
                            >
                                &times;
                            </button>
                            <img
                                src={imageUrl}
                                alt={`${gameConfiguration.label} configuration image`}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default GameConfigurationCard;
